import { createContext } from 'react';
import { DataBoostTheme, DataPackageTheme } from './themes';

export type CampaignThemeContextType = (DataBoostTheme | DataPackageTheme)[]

export const CampaignThemeContext = createContext<CampaignThemeContextType>([]);

export const CampaignThemeProvider = CampaignThemeContext.Provider
